import { LANGUAGE_MARKETS, getLanguageMarket } from '../locales/index.js';

export const SEO_SUPPORTED_LANGUAGE_CODES = Object.keys(LANGUAGE_MARKETS);

export const getSupportedLocaleTags = (languages = SEO_SUPPORTED_LANGUAGE_CODES) => (
  Array.from(new Set(
    (Array.isArray(languages) ? languages : [])
      .map((language) => getLanguageMarket(language).localeTag)
      .filter(Boolean)
  ))
);

export const getSupportedCountryCodes = (languages = SEO_SUPPORTED_LANGUAGE_CODES) => (
  Array.from(new Set(
    (Array.isArray(languages) ? languages : [])
      .map((language) => getLanguageMarket(language).country)
      .filter(Boolean)
  ))
);
